import React, { useContext, useEffect } from "react";

import { useMutation } from "@apollo/client";
import qs from "qs";
import { useHistory, useLocation, useParams } from "react-router";
import Spin from "shared/components/Spin";
import { SIGN_IN_WITH_PROVIDER } from "shared/graphql/mutations";
import { StoreContext } from "shared/store";
import { PATHS } from "utils/constants";

const AuthRedirection = () => {
  const { setRefreshToken, setProvider, setLoggedIn } =
    useContext(StoreContext);
  const history = useHistory();
  const { provider } = useParams();
  const location = useLocation();

  const onComplete = async ({ refresh_token }) => {
    setLoggedIn(true);
    setRefreshToken(refresh_token);
    history.push(PATHS.FILE.HOME);
  };
  const onError = () => {
    history.push(`${PATHS.ERROR}`);
  };

  const [signInWithProvider] = useMutation(SIGN_IN_WITH_PROVIDER, {
    onCompleted: ({ signInWithProvider: result }) => onComplete(result),
    onError,
  });

  const {
    code,
    error_description: errorDescription,
    error,
  } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    code && signInWithProvider({ variables: { provider, code } });
  }, [code]);

  useEffect(() => {
    setProvider(provider);
  }, [provider]);

  useEffect(() => {
    if (error) {
      history.push(`${PATHS.ERROR}?description=${errorDescription}`);
    }
  }, [error, errorDescription]);

  return (
    <div>
      <Spin />
    </div>
  );
};

export default AuthRedirection;
